import React from 'react';
import { useSelector } from 'react-redux';

import { SkeletonTable } from 'ui/components/skeleton';
import { currencyFormat } from 'utilities/common';

export const Coaes = ({ data }) => {
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Closing.Show']
  );

  if (StateLoading) {
    return <SkeletonTable headerCount={5} bodyCount={5} />;
  }

  return (
    <div>
      <div className="hr-text hr-text-left text-primary mb-3 mt-md-3 mt-3">
        Informasi Coa
      </div>
      <div className="table-responsive m-0">
        <table
          width="100%"
          className="table table-hover table-vcenter card-table datatable border"
        >
          <thead className="bg-light">
            <tr className="th">
              <td style={{ whiteSpace: 'initial', width: '50px' }}>
                Code
              </td>
              <td style={{ whiteSpace: 'initial', width: '500px' }}>
                Keterangan
              </td>
              <td
                style={{
                  whiteSpace: 'initial',
                  width: '120px',
                  textAlign: 'end',
                }}
              >
                Debit
              </td>
              <td
                style={{
                  whiteSpace: 'initial',
                  width: '120px',
                  textAlign: 'end',
                }}
              >
                Credit
              </td>
            </tr>
          </thead>
          <tbody>
            {data?.coaes?.map((s, i) => (
              <tr key={i}>
                <td style={{ whiteSpace: 'initial', width: '50px' }}>
                  <div className="table-col">
                    <div className="text-ellipsis text-uppercase">
                      {s?.coa?.code}
                    </div>
                  </div>
                </td>
                <td style={{ whiteSpace: 'initial', width: '200px' }}>
                  <div className="table-col">
                    <div className="text-ellipsis text-uppercase">
                      {s?.coa?.name}
                    </div>
                  </div>
                </td>
                <td
                  style={{
                    whiteSpace: 'initial',
                    width: '120px',
                    textAlign: 'end',
                  }}
                >
                  {currencyFormat(s?.debit)}
                </td>
                <td
                  style={{
                    whiteSpace: 'initial',
                    width: '120px',
                    textAlign: 'end',
                  }}
                >
                  {currencyFormat(s?.credit)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
